export enum InvoiceType {
  CASE = "case",
  INVOICE = "invoice",
}

export enum DebtorType {
  COMPANY = "Company",
  PERSON = "Person",
}

export enum CountryCode {
  NORWAY = "NO",
  SWEDEN = "SE",
  DENMARK = "DK",
}
